<template>
  <publicaties />
</template>

<script>
import Publicaties from '../components/KeuzesUitvaart/Publicaties.vue'

export default {
  name: 'PublicatiesView',
  components: {
    Publicaties
  }
}
</script>
